// Эндпоинты и типы для программ и наборов программ (админ)

export interface Program {
    id: number;
    name: string;
    description: string;
    price_enter: number;
    price_month: number;
    price_year: number;
    type: string;
    safe_dividend_percent: number;
    safe_payment_interval: number;
}

export interface ProgramSet {
    id: number;
    name: string;
    description: string;
    price_enter: number;
    programs: { id: number; name: string }[];
}

export const programsEndpoints = {
    getPrograms: {
        query: () => "/programs",
    },
    createProgram: {
        query: (body: Omit<Program, "id">) => ({
            url: "/programs",
            method: "POST",
            body,
        }),
    },
    updateProgram: {
        query: (args: { id: number } & Omit<Program, "id">) => ({
            url: `/programs/${args.id}`,
            method: "PUT",
            body: args,
        }),
    },
    deleteProgram: {
        query: (id: number) => ({
            url: `/programs/${id}`,
            method: "DELETE",
        }),
    },

    getProgramSets: {
        query: () => "/program-sets",
    },
    createProgramSet: {
        query: (body: {
            name: string;
            description: string;
            price_enter: number;
            programs: number[];
        }) => ({
            url: "/program-sets",
            method: "POST",
            body,
        }),
    },
    updateProgramSet: {
        query: (args: {
            id: number;
            name: string;
            description: string;
            price_enter: number;
            programs: number[];
        }) => ({
            url: `/program-sets/${args.id}`,
            method: "PUT",
            body: args,
        }),
    },
    deleteProgramSet: {
        query: (id: number) => ({
            url: `/program-sets/${id}`,
            method: "DELETE",
        }),
    },
};

export const programsTags = ["Programs"] as const;
